module.exports = __webpack_public_path__ + "img/form-settings-description.85d5f7fe.svg";